import React from 'react'
import { RadioButton } from 'primereact/radiobutton'

const RadioInput = (props: {
    checked: boolean
    onChange: (input?: any) => void
    name?: string
    label: string
}) => {
    const { checked, onChange, name, label } = props
    return (
        <div className="w-100 p-d-flex p-ai-center">
            <RadioButton
                inputId={'radio' + name}
                value={name}
                checked={checked}
                onChange={onChange}
            />
            <label htmlFor={'radio' + name} className="p-pl-2 my-auto">
                {label}
            </label>
        </div>
    )
}

export default RadioInput
